module.exports = __webpack_public_path__ + "img/lideranca_ouro.89b0cfdc.png";